const isProd = true;
export const APP_BASE_URL = isProd ? "https://app.mvrc.co.in" : "https://6fqm9v96-8000.inc1.devtunnels.ms";
export const CLINIC_BASE_URL = "https://mvrc.pythonanywhere.com";
export const clinicToken = "bdb1cd21aed83f83b95b10bbcd3e6b3565ed2d2a";
export const accountantLoginApiUrl = `${APP_BASE_URL}/clinic/accountant-login/`;

// APi for hardware Url  //
export const exportPackageExcelApi = `${APP_BASE_URL}/invoice/export-package-invoices/`;
// EX: `${APP_BASE_URL}/invoice/export-package-invoices/<center>/<from>/<to>/`;
export const exportConsultationExcelApi = `${APP_BASE_URL}/invoice/export-consultation-invoices/`;
export const exportPackageInvoiceAccountsApi = `${APP_BASE_URL}/invoice/package-invoices-hud`;
export const exportMedicineExcelApi = `${APP_BASE_URL}/invoice/export-medicine-invoices/`;
export const exportMedicineCenterReportApi = `${APP_BASE_URL}/invoice/medicine-report-center/`;
export const updatePackageStatusApi = `${APP_BASE_URL}/invoice/update-package-status/`;
export const updateConsultationStatusApi = `${APP_BASE_URL}/invoice/update-consultation-status/`;
export const updateMedicineStatusApi = `${APP_BASE_URL}/invoice/update-medicine-status/`;
export const accountDashboardApi = `${APP_BASE_URL}/invoice/accountant-dashboard/`;
